module.exports = __webpack_public_path__ + "img/6-text.baa694a2.png";